<div class="loader-container" *ngIf="loaderInfo.state">
  <img class="zoom-in-out" src="/assets/images/loader/icon.svg" />
  <div class="loader-text" [innerHTML]="'loader_Data1' | i18n" *ngIf="loaderInfo.type === loaderTypes.NONE"></div>
</div>
